/**
 * The public status page linked when a deployment has not named its own
 * (`STATUS_PAGE_URL` unset). Shared because two sides fall back to it: the
 * backend when the env var is unset, and the client while it cannot ask the
 * backend — the boot-failure screen renders exactly when that may be the case.
 */
export const DEFAULT_STATUS_PAGE_URL =
	"https://deploy.onedeploy.dev/status/hub.oneai.eu";
